import { render, staticRenderFns } from "./Moves.vue?vue&type=template&id=6c69da66&scoped=true"
import script from "./Moves.vue?vue&type=script&lang=js"
export * from "./Moves.vue?vue&type=script&lang=js"
import style0 from "./Moves.vue?vue&type=style&index=0&id=6c69da66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c69da66",
  null
  
)

export default component.exports